export const option_tipo_paquete: any = [
  {
    id: 'convencional',
    name: 'Valor convencional',
  },
  {
    id: 'paquetes',
    name: 'Paquete',
  },
]
export const option_tipo_isapre: any = [
  {
    id: 1,
    name: 'ISAPRE BANMEDICA',
  },
  {
    id: 2,
    name: 'ISAPRE CRUZ BLANCA',
  },
  {
    id: 63,
    name: 'ISAPRE FUSAT',
  },
  {
    id: 65,
    name: 'ISAPRE CHUQUICAMATA',
  },
  {
    id: 67,
    name: 'ISAPRE COLMENA',
  },
  {
    id: 68,
    name: 'ISAPRE RIO BLANCO',
  },
  {
    id: 76,
    name: 'ISAPRE FUNDACION',
  },
  {
    id: 80,
    name: 'ISAPRE VIDA TRES',
  },
  {
    id: 107,
    name: 'ISAPRE CONSALUD',
  },
  {
    id: 108,
    name: 'SAN LORENZO ISAPRE LTDA.',
  },
  {
    id: 199,
    name: 'FONASA (FONDO NACIONAL DE SALUD)',
  },
  {
    id: 300,
    name: 'PARTICULAR',
  },
  {
    id: 884,
    name: 'ISAPRE NUEVA MASVIDA',
  },
]
